import React from 'react';

import PlaceTitle from './title';
import GpxUpload from './gpxUpload';
import CreatedBy from './CreatedBy';
import PlaceCategoryView from './category';
import PlaceAccessTypes from './accessTypes';

const PlaceHeader = (props) => {
  const { edit } = props;

  return (
    <div className="mainTitle">
      <div className="title">
        <PlaceTitle />
      </div>
      <div className="infoTourFullTitle">
        <div className="wrapper-distance-upload">
          <span className="distance">
            <PlaceCategoryView />
          </span>
          {edit ? <GpxUpload /> : <CreatedBy />}
        </div>
        <div className="tour-title-devider" />
        <div className="wrapper-access-road-types">
          <div className="tourTypeIcon">{/* <PlaceTypeIconView /> */}</div>
          <PlaceAccessTypes />
        </div>
      </div>
    </div>
  );
};

export default PlaceHeader;
